module.exports = __webpack_public_path__ + "img/video-stimuli-symbol.3e39528c.svg";